import React from "react";
import dance1 from "../../../images/dance-kindness1.jpg";
import dance2 from "../../../images/dance-kindness2.jpg";
import dance3 from "../../../images/dance-kindness3.jpg";
import dance4 from "../../../images/dance-kindness4.jpg";
import dance5 from "../../../images/dance-kindness5.jpg";
import dance6 from "../../../images/dance-kindness6.jpg";
import dance7 from "../../../images/dance-kindness7.jpg";
import dance8 from "../../../images/dance-kindness8.jpg";
import dance9 from "../../../images/dance-kindness9.jpg";
import dance10 from "../../../images/dance-kindness10.jpg";
import dance11 from "../../../images/dance-kindness11.jpg";
import dance12 from "../../../images/dance-kindness12.jpg";
import dance13 from "../../../images/dance-kindness13.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const DanceKindness = () => (
  <EngagementCarouselPage
    title="Dance for Kindness"
    videos={[
      "https://www.youtube.com/embed/UpdxVuZwvDI",
      "https://www.youtube.com/embed/Floq0FkcEEs",
    ]}
    paragraphs={[
      "In the November of 2013 and 2014, as a way to launch World Kindness Week, Kindness Unlimited in association with Life Vest Inside, a U.S. based NPO, organized a flash dance across the country that brought together hundreds of people from different backgrounds to stand united and dance together under the banner of kindness, a move that showed the overwhelming public support towards our shared vision for a kinder world.",
    ]}
    images={[dance1, dance2, dance3, dance4, dance5, dance6, dance7, dance8, dance9, dance10, dance11, dance12, dance13]}
  />
);

export default DanceKindness;
